import * as React from 'react';
import {NotionWrapper} from '@ux/notion-api';

const NotionGridVisualEffects = () => (
	<NotionWrapper blockMap={{
	"blocks": [
		{
			"id": "5f304e57-18f8-4cd9-b80b-07951787740a",
			"type": "page",
			"properties": {
				"title": [
					[
						"Эффекты"
					]
				]
			},
			"content": [
				"36b3e418-8f79-4be3-95e4-a5203141a719",
				"460f6b99-10f4-4554-a50b-97ddc741aaf1",
				"663da69a-3064-4b76-b2a9-7dffbfdc699e",
				"8c34f6c3-1de2-4c0d-a13a-70a5e0d6648d",
				"6b71baac-46c9-46a8-87db-012d1b47de29",
				"ec27c132-3b84-47f1-89c1-eb65657ab37e",
				"1e43c21f-c6d3-4fb6-83a7-728763726228",
				"f637fa10-a30e-438b-ace5-8aaae873386a",
				"58cb5091-cacb-4960-adfb-edcefff04dae",
				"aa2707a2-30d9-4563-9038-faa4681f140f",
				"67fae055-494a-4ff6-a176-8447181d7bd1",
				"ed0ff8b1-6f59-4e42-b38c-a2083b6244fd",
				"ccae7ccf-2364-4385-945d-fe3cfc92dc0e",
				"02622f18-0e1a-49e5-b174-2f92366e9653",
				"f4b974cc-c9da-4951-88fb-402f0488983b",
				"a3bfe598-b8d7-4649-98b7-c136d15f96ad",
				"82754b0b-d9be-4b19-92df-283a5833f1e3",
				"25aa6b94-c808-4466-9b57-85de6be28918",
				"31bf6985-a2e7-4bae-920a-f973b39ad867",
				"534dd35f-18c2-4afe-8e73-67fcb11ed909",
				"3fec0368-fc66-4e13-bccf-f4c6d2afec64",
				"23fee03c-c453-4145-af12-92a7681fbdea",
				"f2bcac87-8271-4db3-ae8a-0cf86cf5ba26",
				"73789104-4468-40be-bd42-879fb9d3bcca",
				"67c20b34-80c4-4389-8f45-3ceae8b097c0",
				"ae03cb8b-b473-4931-97ed-9621058f595e",
				"4f8c42cf-f1fe-4dfe-a556-a43147179eff",
				"c5fcab63-e34f-4607-84e0-e22a25fb9ee3",
				"ea707c62-e886-43cb-a057-2d085f62afef",
				"3d76d4e5-4405-4b45-bcf5-bcc3876442e0",
				"fb825347-1c01-489f-979d-1a86b5eeab48",
				"b0a2cf2d-9727-4c12-b34f-a3c9c9369eeb",
				"19d15077-b2bb-4d5e-ac8d-37e64b07bd56",
				"7dc47f01-a856-4380-820f-21797f81a94a",
				"b55bcd77-374f-4447-9598-40e84467c480",
				"da7656de-6455-4bc0-9341-385d5e4753ec"
			],
			"format": {
				"copied_from_pointer": {
					"id": "5259af59-2789-48b2-aeaf-022c5b6cb960",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "a7f0ba9f-a91a-4924-8447-b93845e6da1c",
			"parent_table": "block",
			"file_ids": [
				"00297e93-632e-4d34-8f0d-52d30cd6210d"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a7f0ba9f-a91a-4924-8447-b93845e6da1c",
			"type": "page",
			"properties": {
				"title": [
					[
						"Paradigm"
					]
				]
			},
			"content": [
				"d4e0a1ac-e02e-4158-9d96-534ae9fa2c53",
				"b091b55a-a32c-4567-82d7-65c50636e3a7",
				"4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
				"7adbd680-541d-4e6e-97d1-f277bd1610c0",
				"ec15c567-4038-4c10-81bb-0a86aee56b08",
				"9a57d34b-41d2-40e4-8c4d-132953b7a175",
				"da552996-155b-442f-9ecf-0bdce521a35e",
				"1f51d543-236b-4b29-a278-4bed543f50b5",
				"5f304e57-18f8-4cd9-b80b-07951787740a",
				"f5097b73-1152-4e95-8919-54eed014af82",
				"94cd6ab9-c518-4094-829c-36d8a73e8010",
				"88cf99fd-dc9d-4649-8601-eb5198351e06",
				"d21336ae-ecfc-4130-a757-19109a89ad74",
				"e916c9a3-5983-4c34-bec3-187e417c593c",
				"cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
				"7ba8f4fe-6d71-4e1f-a1eb-1df9e3da0099",
				"31c9a6bd-328b-4869-aecd-fabd86f3cf15",
				"cb2b1b2c-b795-4abf-b11f-772b33e43908",
				"a47c1d35-578a-4679-8907-d8b13ab1bb65",
				"41e2749d-ddd3-4a06-b224-0ae6b4c9d436",
				"c3e7c6b7-650d-456d-8997-a4d049587d58",
				"7472c506-f9da-4f2e-85ba-59623551e747",
				"16b738c5-499f-42a0-baf4-cffb990a0b25",
				"51181f46-f9ad-4d25-b2c3-a59f7c7b8587",
				"e8ea6408-fc0d-4be8-8020-e982cc7c9b55",
				"3143e3ff-a6eb-4e48-8197-d96fceb48f9e",
				"20802187-e25a-4d38-af64-a363ffcace1d",
				"311c23ba-4ac6-48a0-bf3b-de8b115c363f",
				"aec03706-7113-42af-8724-4b446502d53a",
				"4836526c-ce6a-4bfd-8c2f-4bcb9a446e1e",
				"e0b8f319-a947-4c5d-8bdf-cd0ffeea5a6d",
				"aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
				"98a66dbd-731e-498f-9c5f-7790d1f555e0",
				"c7ec9e06-de22-4861-88e6-e6d45e0de285",
				"55690b50-0664-4442-9ded-4645f2f318e9"
			],
			"parent_id": "1fcd74a2-648f-4dfc-a4d8-abbb9a7bfb29",
			"parent_table": "team",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "36b3e418-8f79-4be3-95e4-a5203141a719",
			"type": "code",
			"properties": {
				"title": [
					[
						"<meta type=\"url\" value=\"/grid/visual_effects\"/>"
					]
				],
				"language": [
					[
						"JavaScript"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "5ec5be76-efc5-432d-9606-c0f77b247c89",
					"table": "block",
					"spaceId": "22066aad-9295-4afc-88d1-dae5d26fea31"
				}
			},
			"parent_id": "5f304e57-18f8-4cd9-b80b-07951787740a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "460f6b99-10f4-4554-a50b-97ddc741aaf1",
			"type": "text",
			"properties": {
				"title": [
					[
						"Визуальные эффекты в интерфейсе нужны не только для красоты — они делают продукт понятнее и снижают когнитивную нагрузку. Важно применять эффекты осмысленно и не использовать там, где от них нет пользы."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "2fa08152-5ed1-4d98-9e76-2b884de123b3",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "5f304e57-18f8-4cd9-b80b-07951787740a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "663da69a-3064-4b76-b2a9-7dffbfdc699e",
			"type": "image",
			"properties": {
				"size": [
					[
						"146.9KB"
					]
				],
				"title": [
					[
						"image.png"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/55c1be5b-83d5-440c-b294-20c4c93cd3ce/image.png"
					]
				]
			},
			"format": {
				"block_width": 1456,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/55c1be5b-83d5-440c-b294-20c4c93cd3ce/image.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5494505494505495,
				"block_preserve_scale": true
			},
			"parent_id": "5f304e57-18f8-4cd9-b80b-07951787740a",
			"parent_table": "block",
			"file_ids": [
				"55c1be5b-83d5-440c-b294-20c4c93cd3ce"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/663da69a-3064-4b76-b2a9-7dffbfdc699e.png"
		},
		{
			"id": "8c34f6c3-1de2-4c0d-a13a-70a5e0d6648d",
			"type": "header",
			"properties": {
				"title": [
					[
						"Тень"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "904bf42d-675b-476a-8fa2-a3a19945ff55",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "5f304e57-18f8-4cd9-b80b-07951787740a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "6b71baac-46c9-46a8-87db-012d1b47de29",
			"type": "text",
			"properties": {
				"title": [
					[
						"Тень — самый простой способ показать визуальную иерархию. Один слой «приподнимается» над другим, что показывает их взаимоотношение и иерархию компонентов."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "3df9bc8b-9a61-48b1-a7d9-947f9bf56028",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "5f304e57-18f8-4cd9-b80b-07951787740a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ec27c132-3b84-47f1-89c1-eb65657ab37e",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Информационные слои"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "b1589523-956b-4bbb-9f98-47067064f683",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "5f304e57-18f8-4cd9-b80b-07951787740a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "1e43c21f-c6d3-4fb6-83a7-728763726228",
			"type": "text",
			"properties": {
				"title": [
					[
						"Информационные слои плоские, но имеют глубину друг относительно друга. Это позволяет быстрее воспринимать иерархию и функции элементов интерфейса."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "b65f0cd1-e7dd-4752-a7ba-271d5363d14d",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "5f304e57-18f8-4cd9-b80b-07951787740a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "f637fa10-a30e-438b-ace5-8aaae873386a",
			"type": "image",
			"properties": {
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/3460319d-08e1-4ec4-b64d-1ebd8ce6a176/infolayers.png"
					]
				]
			},
			"format": {
				"block_width": 2184,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/3460319d-08e1-4ec4-b64d-1ebd8ce6a176/infolayers.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5535714285714286,
				"copied_from_pointer": {
					"id": "51fcbbf5-075a-4418-87b8-3a176659d027",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": true
			},
			"parent_id": "5f304e57-18f8-4cd9-b80b-07951787740a",
			"parent_table": "block",
			"file_ids": [
				"3460319d-08e1-4ec4-b64d-1ebd8ce6a176"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/f637fa10-a30e-438b-ace5-8aaae873386a.png"
		},
		{
			"id": "58cb5091-cacb-4960-adfb-edcefff04dae",
			"type": "text",
			"format": {
				"copied_from_pointer": {
					"id": "ad18aa10-3283-4883-bc9f-c27575b0aa03",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "5f304e57-18f8-4cd9-b80b-07951787740a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "aa2707a2-30d9-4563-9038-faa4681f140f",
			"type": "text",
			"properties": {
				"title": [
					[
						"Мы стараемся не применять тени в базовых компонентах и использовать их для выделения иерархии или визуального акцента."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "62a521d1-01f9-4ecd-9f46-580be30e36b6",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "5f304e57-18f8-4cd9-b80b-07951787740a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "67fae055-494a-4ff6-a176-8447181d7bd1",
			"type": "column_list",
			"content": [
				"6f3eeab2-ed9d-4d94-bfb5-12c77fd14831",
				"09dff15e-eb12-4ce7-8efb-0852741f1192"
			],
			"format": {
				"copied_from_pointer": {
					"id": "370e7e7a-259c-43da-96a8-ac3a039664e2",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "5f304e57-18f8-4cd9-b80b-07951787740a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ed0ff8b1-6f59-4e42-b38c-a2083b6244fd",
			"type": "header",
			"properties": {
				"title": [
					[
						"Затемнение"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "284cbd42-77ed-4e3b-9ba2-9129485f0035",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "5f304e57-18f8-4cd9-b80b-07951787740a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ccae7ccf-2364-4385-945d-fe3cfc92dc0e",
			"type": "text",
			"properties": {
				"title": [
					[
						"Когда нужно сфокусировать внимание на одном интерфейсном блоке, используется затемнение. Есть три прозрачности для тонирования. Выбор прозрачности зависит от того, насколько нагружен интерфейс поверх затемнения."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "6b743fe3-4b71-491f-a6a3-999860b525e7",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "5f304e57-18f8-4cd9-b80b-07951787740a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "02622f18-0e1a-49e5-b174-2f92366e9653",
			"type": "image",
			"properties": {
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/798b92b5-795e-4d16-b69e-3ac0939c2179/overlay.png"
					]
				]
			},
			"format": {
				"block_width": 1456,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/798b92b5-795e-4d16-b69e-3ac0939c2179/overlay.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5631868131868132,
				"copied_from_pointer": {
					"id": "de692fe1-08e7-473d-bce8-17fe670ad4c9",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": true
			},
			"parent_id": "5f304e57-18f8-4cd9-b80b-07951787740a",
			"parent_table": "block",
			"file_ids": [
				"798b92b5-795e-4d16-b69e-3ac0939c2179"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/02622f18-0e1a-49e5-b174-2f92366e9653.png"
		},
		{
			"id": "f4b974cc-c9da-4951-88fb-402f0488983b",
			"type": "text",
			"format": {
				"copied_from_pointer": {
					"id": "9a3b056b-6d80-4379-ac47-c6590159ebbc",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "5f304e57-18f8-4cd9-b80b-07951787740a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a3bfe598-b8d7-4649-98b7-c136d15f96ad",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Градиенты"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "1b7d0f6e-bf46-4fa1-b466-44dcc4ee5f2c",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "5f304e57-18f8-4cd9-b80b-07951787740a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "82754b0b-d9be-4b19-92df-283a5833f1e3",
			"type": "text",
			"properties": {
				"title": [
					[
						"Градиент используется, если необходимо сделать затемнение для фото. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "3583547f-3db7-4810-86b0-24b52a619678",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "5f304e57-18f8-4cd9-b80b-07951787740a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "25aa6b94-c808-4466-9b57-85de6be28918",
			"type": "column_list",
			"content": [
				"2b57b8b1-42c6-466f-9115-ae628bb250a4",
				"196b3169-e7b8-4f5e-9bc4-484b7c3d01e0"
			],
			"format": {
				"copied_from_pointer": {
					"id": "a4004ac3-d6a8-4eec-93fc-2d0a14ed4ac8",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "5f304e57-18f8-4cd9-b80b-07951787740a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "31bf6985-a2e7-4bae-920a-f973b39ad867",
			"type": "text",
			"format": {
				"copied_from_pointer": {
					"id": "2ff3d08d-72ff-4f07-94c1-9a2183bb1a54",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "5f304e57-18f8-4cd9-b80b-07951787740a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "534dd35f-18c2-4afe-8e73-67fcb11ed909",
			"type": "text",
			"properties": {
				"title": [
					[
						"Рекомендуем создавать градиент не из оттенков чисто черного, а из холодного черного —  "
					],
					[
						"#00060F",
						[
							[
								"b"
							]
						]
					],
					[
						"."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "9a3f8e9a-ca9b-47e3-b132-4724ec3a9fd9",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "5f304e57-18f8-4cd9-b80b-07951787740a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "3fec0368-fc66-4e13-bccf-f4c6d2afec64",
			"type": "image",
			"properties": {
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/058d6969-1e01-4d16-9e92-457e38cf9d9b/00060f.png"
					]
				]
			},
			"format": {
				"block_width": 1456,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/058d6969-1e01-4d16-9e92-457e38cf9d9b/00060f.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.41208791208791207,
				"copied_from_pointer": {
					"id": "366a71c6-f258-4d25-8a11-b954b538d214",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": true
			},
			"parent_id": "5f304e57-18f8-4cd9-b80b-07951787740a",
			"parent_table": "block",
			"file_ids": [
				"058d6969-1e01-4d16-9e92-457e38cf9d9b"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/3fec0368-fc66-4e13-bccf-f4c6d2afec64.png"
		},
		{
			"id": "23fee03c-c453-4145-af12-92a7681fbdea",
			"type": "text",
			"format": {
				"copied_from_pointer": {
					"id": "145d65db-8790-4efc-8d4e-860aa4f17787",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "5f304e57-18f8-4cd9-b80b-07951787740a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "f2bcac87-8271-4db3-ae8a-0cf86cf5ba26",
			"type": "text",
			"properties": {
				"title": [
					[
						"Линейный градиент имеет характерные заломы. Поэтому рекомендуем использовать сглаженные градиенты — это сделает эффект более приятным на вид."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "89643c3c-60be-4b0b-8729-5e64421fcae0",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "5f304e57-18f8-4cd9-b80b-07951787740a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "73789104-4468-40be-bd42-879fb9d3bcca",
			"type": "image",
			"properties": {
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/83ff82ee-c3e1-4fb1-9611-0881cb1c2d64/easing_gradient.png"
					]
				]
			},
			"format": {
				"block_width": 1456,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/83ff82ee-c3e1-4fb1-9611-0881cb1c2d64/easing_gradient.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.760989010989011,
				"copied_from_pointer": {
					"id": "74981507-0a22-48dd-a99b-6aab00cddf46",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": true
			},
			"parent_id": "5f304e57-18f8-4cd9-b80b-07951787740a",
			"parent_table": "block",
			"file_ids": [
				"83ff82ee-c3e1-4fb1-9611-0881cb1c2d64"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/73789104-4468-40be-bd42-879fb9d3bcca.png"
		},
		{
			"id": "67c20b34-80c4-4389-8f45-3ceae8b097c0",
			"type": "text",
			"properties": {
				"title": [
					[
						"linear-gradient(180deg, rgba(0, 6, 15, 0) 0%, rgba(0, 6, 15, 0.02) 12%, rgba(0, 6, 15, 0.13) 26%, rgba(0, 6, 15, 0.79) 73%, rgba(0, 6, 15, 1) 100%);"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "9a5a6d16-3b24-4ef2-93ad-2e38e1f79e25",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "5f304e57-18f8-4cd9-b80b-07951787740a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ae03cb8b-b473-4931-97ed-9621058f595e",
			"type": "text",
			"format": {
				"copied_from_pointer": {
					"id": "3adbadfb-cafe-4f38-8894-2b95868824c2",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "5f304e57-18f8-4cd9-b80b-07951787740a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "4f8c42cf-f1fe-4dfe-a556-a43147179eff",
			"type": "text",
			"properties": {
				"title": [
					[
						"В переходах между цветами тоже есть такой эффект, поэтому рекомендуем сглаживать градиенты."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "b25ede56-4cdb-4000-a51c-e7fb0068f6d3",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "5f304e57-18f8-4cd9-b80b-07951787740a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "c5fcab63-e34f-4607-84e0-e22a25fb9ee3",
			"type": "header",
			"properties": {
				"title": [
					[
						"Эффект наведения"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "83d71310-81bb-4e12-b95e-4882f50e8810",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "5f304e57-18f8-4cd9-b80b-07951787740a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ea707c62-e886-43cb-a057-2d085f62afef",
			"type": "text",
			"properties": {
				"title": [
					[
						"Понятный интерфейс должен отзываться на действия пользователя, поэтому важно, чтобы любой интерактивный элемент реагировал на наведение."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "154b0b75-ea3d-4c50-8bd3-2503533b576a",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "5f304e57-18f8-4cd9-b80b-07951787740a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "3d76d4e5-4405-4b45-bcf5-bcc3876442e0",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Тонирование"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "3471130d-a6a4-4f34-b9d6-42ae6312b16e",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "5f304e57-18f8-4cd9-b80b-07951787740a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "fb825347-1c01-489f-979d-1a86b5eeab48",
			"type": "text",
			"properties": {
				"title": [
					[
						"Тонирование элемента это стандартный приём фидбэка, а в качестве тонера мы используем цвет. У простых контролов вроде инпута также меняется цвет обводки."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "c912ce4a-a904-4c5e-90ab-e7d9407efa40",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "5f304e57-18f8-4cd9-b80b-07951787740a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b0a2cf2d-9727-4c12-b34f-a3c9c9369eeb",
			"type": "image",
			"properties": {
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/15cd5674-6a3f-4378-be67-147679e6484d/main.gif"
					]
				]
			},
			"format": {
				"block_width": 582,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/15cd5674-6a3f-4378-be67-147679e6484d/main.gif",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5631868131868132,
				"copied_from_pointer": {
					"id": "daf45607-a676-4c2f-8add-d4e856168112",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": true
			},
			"parent_id": "5f304e57-18f8-4cd9-b80b-07951787740a",
			"parent_table": "block",
			"file_ids": [
				"15cd5674-6a3f-4378-be67-147679e6484d"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/b0a2cf2d-9727-4c12-b34f-a3c9c9369eeb.gif"
		},
		{
			"id": "19d15077-b2bb-4d5e-ac8d-37e64b07bd56",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Масштаб"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "12dd6041-b3cc-4baa-959e-502ea830905e",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "5f304e57-18f8-4cd9-b80b-07951787740a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "7dc47f01-a856-4380-820f-21797f81a94a",
			"type": "text",
			"properties": {
				"title": [
					[
						"Когда элемент используется не только для клика, но и является интерактивным элементом, рекомендуем использовать более явную визуальную отдачу."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "e0d59e7c-0782-4432-bb72-fd9adf82be98",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "5f304e57-18f8-4cd9-b80b-07951787740a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b55bcd77-374f-4447-9598-40e84467c480",
			"type": "image",
			"properties": {
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/7998e3e8-4742-4674-912f-a85597121aeb/main_1.gif"
					]
				]
			},
			"format": {
				"block_width": 582,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/7998e3e8-4742-4674-912f-a85597121aeb/main_1.gif",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5631868131868132,
				"copied_from_pointer": {
					"id": "18d6132c-723b-4e60-b1d2-9d736aebc0b7",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": true
			},
			"parent_id": "5f304e57-18f8-4cd9-b80b-07951787740a",
			"parent_table": "block",
			"file_ids": [
				"7998e3e8-4742-4674-912f-a85597121aeb"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/b55bcd77-374f-4447-9598-40e84467c480.gif"
		},
		{
			"id": "da7656de-6455-4bc0-9341-385d5e4753ec",
			"type": "text",
			"format": {
				"copied_from_pointer": {
					"id": "eb3af201-61af-4bad-b12b-820f92059eed",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "5f304e57-18f8-4cd9-b80b-07951787740a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "6f3eeab2-ed9d-4d94-bfb5-12c77fd14831",
			"type": "column",
			"content": [
				"357c75d8-3282-4c5f-b8cc-b70359ef60d3",
				"68929360-02de-4b59-8515-ce35aaa6e94f"
			],
			"format": {
				"column_ratio": 0.5000000000000001,
				"copied_from_pointer": {
					"id": "004fa72d-e34e-4cb5-b454-032b764f6956",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "67fae055-494a-4ff6-a176-8447181d7bd1",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "09dff15e-eb12-4ce7-8efb-0852741f1192",
			"type": "column",
			"content": [
				"f64a2b04-fecf-40de-9992-2c6d3d131cb7",
				"44610e7b-0d3c-451d-9fee-f3c8c64c9673"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "c1509b99-9c13-468a-9509-63f4c24a850a",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "67fae055-494a-4ff6-a176-8447181d7bd1",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "357c75d8-3282-4c5f-b8cc-b70359ef60d3",
			"type": "image",
			"properties": {
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/59be6927-8c9a-40ae-a3c4-b79cdfcc82ab/y.png"
					]
				]
			},
			"format": {
				"block_width": 856,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/59be6927-8c9a-40ae-a3c4-b79cdfcc82ab/y.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 1,
				"copied_from_pointer": {
					"id": "37bec43e-b70e-486a-930b-17717d4b41cd",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": true
			},
			"parent_id": "6f3eeab2-ed9d-4d94-bfb5-12c77fd14831",
			"parent_table": "block",
			"file_ids": [
				"59be6927-8c9a-40ae-a3c4-b79cdfcc82ab"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/357c75d8-3282-4c5f-b8cc-b70359ef60d3.png"
		},
		{
			"id": "68929360-02de-4b59-8515-ce35aaa6e94f",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Тень выделяет информационный слой"
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "8b5bdac1-c87c-4648-8c59-603327b372e1",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "6f3eeab2-ed9d-4d94-bfb5-12c77fd14831",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "f64a2b04-fecf-40de-9992-2c6d3d131cb7",
			"type": "image",
			"properties": {
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/f6e6f092-a7b9-46ef-baf5-1332a4b13e5f/n.png"
					]
				]
			},
			"format": {
				"block_width": 856,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/f6e6f092-a7b9-46ef-baf5-1332a4b13e5f/n.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 1,
				"copied_from_pointer": {
					"id": "fe53f7f8-5e84-4c04-acb5-2e6d5a27b6ce",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": true
			},
			"parent_id": "09dff15e-eb12-4ce7-8efb-0852741f1192",
			"parent_table": "block",
			"file_ids": [
				"f6e6f092-a7b9-46ef-baf5-1332a4b13e5f"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/f64a2b04-fecf-40de-9992-2c6d3d131cb7.png"
		},
		{
			"id": "44610e7b-0d3c-451d-9fee-f3c8c64c9673",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Интерфейс перегружен"
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "efb7a868-5ead-45bc-8b14-74332b92fb02",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "09dff15e-eb12-4ce7-8efb-0852741f1192",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "2b57b8b1-42c6-466f-9115-ae628bb250a4",
			"type": "column",
			"content": [
				"b2268db8-644d-47e2-82b9-73b5b831842d",
				"9703dba3-3c45-4a68-a9e1-719ff7a08d4e"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "a97c2a9b-1f67-4686-a004-9f1055d5cda7",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "25aa6b94-c808-4466-9b57-85de6be28918",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "196b3169-e7b8-4f5e-9bc4-484b7c3d01e0",
			"type": "column",
			"content": [
				"58a447bd-1446-40d4-b855-d9df2e59b6ff",
				"ba63e3df-dce1-420b-87a4-eaefc03f4143"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "8dce675c-c09a-47af-8a2e-943c065bf1f7",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "25aa6b94-c808-4466-9b57-85de6be28918",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b2268db8-644d-47e2-82b9-73b5b831842d",
			"type": "image",
			"properties": {
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/f25c17a9-7be2-4166-bbe3-cc9747f83d7d/gradients_y.png"
					]
				]
			},
			"format": {
				"block_width": 688,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/f25c17a9-7be2-4166-bbe3-cc9747f83d7d/gradients_y.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.8604651162790697,
				"copied_from_pointer": {
					"id": "21106d6a-59db-4995-b427-4342066bc3f7",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": true
			},
			"parent_id": "2b57b8b1-42c6-466f-9115-ae628bb250a4",
			"parent_table": "block",
			"file_ids": [
				"f25c17a9-7be2-4166-bbe3-cc9747f83d7d"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/b2268db8-644d-47e2-82b9-73b5b831842d.png"
		},
		{
			"id": "9703dba3-3c45-4a68-a9e1-719ff7a08d4e",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Затемнение картинки не усложняет интерфейс"
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "45c6c5cf-e90c-4e77-9f71-b7b79e033c14",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "2b57b8b1-42c6-466f-9115-ae628bb250a4",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "58a447bd-1446-40d4-b855-d9df2e59b6ff",
			"type": "image",
			"properties": {
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/6aaccda8-d62a-4126-98d3-0814dcc7cf2e/gradients_n.png"
					]
				]
			},
			"format": {
				"block_width": 688,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/6aaccda8-d62a-4126-98d3-0814dcc7cf2e/gradients_n.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.8604651162790697,
				"copied_from_pointer": {
					"id": "94587563-e1ad-4c48-9bce-b48db7de6873",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": true
			},
			"parent_id": "196b3169-e7b8-4f5e-9bc4-484b7c3d01e0",
			"parent_table": "block",
			"file_ids": [
				"6aaccda8-d62a-4126-98d3-0814dcc7cf2e"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/58a447bd-1446-40d4-b855-d9df2e59b6ff.png"
		},
		{
			"id": "ba63e3df-dce1-420b-87a4-eaefc03f4143",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Дополнительная граница заливки усложняет интерфейс"
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "f9d14317-da76-4fc0-85c6-ad3aa93c9a4c",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "196b3169-e7b8-4f5e-9bc4-484b7c3d01e0",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		}
	],
	"headers": [
		{
			"title": "Тень",
			"id": "8c34f6c3-1de2-4c0d-a13a-70a5e0d6648d"
		},
		{
			"title": "Затемнение",
			"id": "ed0ff8b1-6f59-4e42-b38c-a2083b6244fd"
		},
		{
			"title": "Эффект наведения",
			"id": "c5fcab63-e34f-4607-84e0-e22a25fb9ee3"
		}
	]
}} />
);

export default NotionGridVisualEffects;
